(function() {
  if (!window.location.pathname.startsWith('/en')) return;

  const PRICE_MAP = {
    '14,95': '£14.95', '14.95': '£14.95',
    '29,95': '£29.95', '29.95': '£29.95',
    '44,95': '£44.95', '44.95': '£44.95',
    '5,95':  '£5.95',  '5.95':  '£5.95',
  };

  function convertEuro(amount) {
    if (PRICE_MAP[amount]) return PRICE_MAP[amount];
    const num = parseFloat(amount.replace(',', '.'));
    if (isNaN(num) || num <= 0) return null;
    const floor = Math.floor(num);
    return `£${(floor + 0.99).toFixed(2)}`;
  }

  function convertText(text) {
    return text.replace(/€\s?(\d+)[,.](\d{2})/g, (match, d, c) => {
      return convertEuro(`${d},${c}`) || match;
    });
  }

  function walkAllTextNodes(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const tag = node.parentElement && node.parentElement.tagName;
          if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(tag)) return NodeFilter.FILTER_REJECT;
          if (node.textContent.includes('€')) return NodeFilter.FILTER_ACCEPT;
          return NodeFilter.FILTER_SKIP;
        }
      }
    );
    const nodes = [];
    let n;
    while (n = walker.nextNode()) nodes.push(n);
    nodes.forEach(n => {
      const converted = convertText(n.textContent);
      if (converted !== n.textContent) n.textContent = converted;
    });
  }

  function processAll() { walkAllTextNodes(document.body); }

  processAll();
  [50, 100, 200, 400, 700, 1000, 1500, 2000, 3000].forEach(ms => setTimeout(processAll, ms));
  setInterval(processAll, 500);

  new MutationObserver(() => processAll()).observe(document.body, {
    childList: true, subtree: true, characterData: true
  });
})();